import { getAuth } from "../common/Helpers";

const tokenHelper = {
  GetTokenData: function() {

      const user = JSON.parse(getAuth());
    
      if (user) {
    
        return user.userName
    
      }
    
      return null;
  },
  GetUserNameTokenData: function(){

    const user = JSON.parse(getAuth());
  
    if (user) {
  
      return user.userName
  
    }
  
    return null;
  },
}

export default tokenHelper;